export const getUser = state => state.user;
export const getIsUserLoggedIn = state => state.user.isLoggedIn;
export const getUserIsAdmin = state => state.user.isAdmin;
export const getCurrentUser = state => state.user;
export const getUserIsLoading = state => state.user.isLoading;
export const getUserRequestDetails = state => state.user.requestDetail;
